import Vue from 'vue';

const state = {
  questionnaires: {},
};

const getters = {
  all: (state) => Object.values(state.questionnaires),
  get: (state) => state.questionnaires,
};

const mutations = {
  set(state, questionnaires) {
    questionnaires.forEach(questionnaire => {
      Vue.set(state.questionnaires, questionnaire.id, questionnaire);
    });
  },
};

const actions = {
  update({ dispatch, commit, getters, rootGetters }, { data, questionnaireId }) {
    const params = {
      id: questionnaireId,
      response: data,
      userId: rootGetters['user/get'].id,
    };
    return rootGetters['session/ajax'].post('/questionnaires', params).then(response => {
      dispatch('user/setUser', response.data.user, { root: true });
      commit('questionnaireUserStates/set', response.data.user.questionnaireUserStates, { root: true });
      commit('flashcards/setFlashcards', { records: response.data.flashcards }, { root: true });
      return response.data.next;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
